import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../program-sheet.module.scss';
import clsx from 'clsx';

import testIds from '@smart-tv/e2e/shared/variables';
import PlaceholderLandscape from '@smart-tv/scaffold/images/placeholder_default_landscape.svg';
import { getPerformanceScore } from '@smart-tv/utils/deviceProfiler';

import { rootStore } from '../_stores/store-root';
import { uiStore } from '../_stores/store-ui';


export const ProgramSheetBackground = observer(() => {
  const { sheet, setLoading } = rootStore.sheetStore;
  const { toggles } = uiStore;
  const [isFocused, setIsFocused] = useState(false);
  const [coverSrc, setCoverSrc] = useState<string | undefined>(undefined);
  const [usingPortraitCover, setUsingPortraitCover] = useState(false);

  React.useEffect(() => {
    if (sheet.cover) {
      const tryCoverSrc = new Image();
      tryCoverSrc.src = sheet.cover;
      tryCoverSrc.onload = () => {
        setCoverSrc(sheet.cover);
        setLoading(false);
      };
      tryCoverSrc.onerror = () => {
        setCoverSrc(PlaceholderLandscape);
      };
    } else {
      const tryPortraitCoverSrc = new Image();
      tryPortraitCoverSrc.src = sheet.portraitCover;
      tryPortraitCoverSrc.onload = () => {
        if (sheet.portraitCover) {
          setCoverSrc(sheet.portraitCover);
          setUsingPortraitCover(true);
          setLoading(false);
        }
      };
      tryPortraitCoverSrc.onerror = () => {
        setCoverSrc(PlaceholderLandscape);
      };
    }
  }, [sheet.cover, sheet.portraitCover, setLoading]);

  const handleFocusToggle = useCallback(() => {
    if (toggles.focusEpisodes) {
      setIsFocused(true);
    } else {
      const timeoutId = setTimeout(
        () => {
          setIsFocused(false);
        },
        getPerformanceScore() === 'low' ? 400 : 0
      );

      return () => clearTimeout(timeoutId);
    }
  }, [toggles.focusEpisodes]);

  useEffect(() => {
    handleFocusToggle();
  }, [handleFocusToggle]);

  return (
    <div className={styles['program-sheet-background']}>
      <div className={styles['program-sheet-background__gradient']} />
      <div 
        className={
          clsx(
            styles['program-sheet-background__image'], 
            isFocused && styles['program-sheet-background__image--focused'],
            getPerformanceScore() === 'low' && styles['program-sheet-background__image--low-performance'],
            usingPortraitCover && styles['program-sheet-background__image--using-portrait-cover']
          )
        }
        style={{ '--image-src': `url(${coverSrc})` } as React.CSSProperties}
      />
    </div>
  );
});

export default ProgramSheetBackground;
